<script>

import {regexPatterns} from "../../../utils/utils";
import {countries} from "../../../utils/countries";
import process from "shelljs";
import {mapActions} from "vuex";

export default {
  name: "uConnectRegistrationSection1",
  data() {
    return {
      alertDialogVisible: false,
      dialogBoxMessage: "",
      dialogBoxTitle: "",
      loadingJoinUConnect: false,
      userTypeErrorCode: 0,
      user: null,
      stripe: "",
      checkout: "",
      checkoutDisplayed: false,
      clientSecret: "",
      loading: false,
      requestToJoinDialogVisible: false,
      requestUConnectForm: {
        email: "",
      },
      rules: {
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
      }
    };
  },
  methods: {
    ...mapActions("uConnect", ["checkUConnectUser"]),
    countries() {
      return countries
    },
    validateField(field) {
      this.$refs.requestToJoinForm.validateField(field);
    },
    goToUConnect() {
      // this will automatically go to the search page,if they are logged in. if they aren't logged in, the page will automatically redirect to the log in page
      window.open(
          `${process.env.VUE_APP_UNIFI_AGENT}#/uconnect/search/results`
      );

    },
    handleCloseRegisterDialog() {
      this.alertDialogVisible = false;
      this.clearUserDetails();

    },
    checkUserAndCreate(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;

          this.checkUConnectUser({
            params: {
              email: this.requestUConnectForm.email,
            },
            callback: this.checkUConnectUserCallback
          });
        }
      });
    },

    checkUConnectUserCallback(res) {
      var that = this;

      if (res.data.code === 60001 || res.data.code === 60002) {

        localStorage.setItem("uConnectRegistrationKey", res.data.data.uConnectRegistrationKey);
        that.$store.commit("uConnect/updateUserDetails", {
          user: {
          email: res.data.data.user.email,
          userId: res.data.data.user.userId
        }
        });
        that.loading = false;
        that.$router.push({name: "uConnectSelectPlanStep"});

      } else if (res.data.code === 70000) {
        that.alertDialogVisible = true;
        that.dialogBoxMessage = res.data.message;
        that.userTypeErrorCode = res.data.code;
        that.dialogBoxTitle = "User Account Exists"
        that.loading = false;
      }

    },
    clearUserDetails() {
      this.requestUConnectForm.email = "";
    },
  },
  mounted() {
  }

}
</script>

<template>
  <div class="page-outer-wrapper">
    <el-row class="main-content">
      <el-col :xs="24" :sm="12" class="left-content">

        <div class="content-wrapper">
          <h2 class="title">U-Connect: Collaborate, Grow,</h2>
          <h3 class="subtitle">and Expand Your Business Today </h3>

          <p class="description">
            Join U-Connect; a B2B platform linking professionals to
            access exclusive off-the-plan properties, collaborate for
            unique revenue stream opportunities and grow your
            national real estate stock list

          </p>

          <el-row>
            <span>Get started for only $89/month.  Enter your email to create your membership.</span>
          </el-row>
          <el-row :gutter="20" style="margin-top: 20px">
<!--            <el-card >-->
              <el-form
                  ref="requestAgentForm"
                  :model="requestUConnectForm"
                  :rules="rules"
                  label-position="top"
                  label-width="100px"
                  @submit.native.prevent
                  style="font-family: DINosaur-a, sans-serif;">
                <el-row>
                  <el-col :span="24">
                    <el-form-item prop="email">
                      <el-input
                          v-model="requestUConnectForm.email"
                          maxlength="100"
                          placeholder="Your email"
                          :disabled="user != null"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item style="text-align:center">
                      <el-button class="join-btn" @click="checkUserAndCreate('requestAgentForm')">
                        Join U-Connect
                        <i v-if="loading" class="el-icon-loading"></i>
                      </el-button>
                    </el-form-item>
                  </el-col>
               </el-row>
              </el-form>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-divider> Already have an Account? </el-divider>
              <el-button
                  type="primary"
                  size="large"
                  class="sign-in-btn"
                  @click="goToUConnect"
              >
                SIGN IN
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>

      <el-col :xs="24" :sm="12" class="right-content">
        <div class="image-wrapper">
          <img class="background-image" src="../../../assets/u-connect-reg-background.png" alt="">
        </div>
      </el-col>
    </el-row>

    <el-dialog
        :before-close="handleCloseRegisterDialog"
        :visible.sync="alertDialogVisible"
        center
        style="margin: 10% 0; font-family: DINosaur-a; color: #003333"
        :title="dialogBoxTitle"
        width="100%"
    >
      <template v-if="userTypeErrorCode === 70000">
           <span class="forgotPasswordSpan"
           >{{this.dialogBoxMessage}}. Please login.</span>

      </template>
      <template v-else-if="userTypeErrorCode === 60001">
                    <span class="forgotPasswordSpan"
                    v-html="dialogBoxMessage" >{{this.dialogBoxMessage}}. Please check your junk mail to ensure you receive
                      it.</span>
      </template>
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="12" :offset="userTypeErrorCode === 70000 ? 0 : 12">
          <el-button
              class="dialog-footer-btn"
              type="primary"
              @click="handleCloseRegisterDialog"
          >Close</el-button
          >
        </el-col>
        <template v-if="userTypeErrorCode === 70000">
          <el-col :span="12">
            <el-button
                class="dialog-footer-btn"
                type="primary"
                @click="goToUConnect"
            >Sign in to U-Connect</el-button>
          </el-col>
        </template>
      </el-row>
    </el-dialog>
  </div>
</template>

<style scoped lang="css">
.main-content {
  display: flex;
  min-height: 60%;
}

.left-content {
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  color: #003333;
  font-size: 18px;
  line-height: 2;
  font-weight: 700;
}

.subtitle {
  color: #003333;
  font-size: 18px;
  font-weight: 600;
  line-height:2;
  margin-bottom: 30px;
}

.description {
  color: #003333;
  font-size: 14px;
  margin-bottom: 40px;
  line-height: 1.5;
}

.sign-in-btn, .join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 5px;
  padding: 15px 0;
  height: max-content;
  font: 500 14px DINosaur-a, sans-serif;
  color: #ffffff;
}

.dialog-footer-btn {
  color: #fff;
  justify-content: center;
  /*white-space: normal; */
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  width: 100%;
  font: 500 14px DINosaur-a, sans-serif;
  padding: 15px 0;
  height: max-content;
}
.right-content {
  position: relative;
}

.image-wrapper {
  width: 90%;
}
.background-image{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
  .left-content {
    padding: 30px;
  }
  .right-content {
    min-height: 300px;
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/uConnectRegistrationSection1.vue